import { BuhReport } from '@app/buhReport';
import { Typography } from 'antd';

const { Title } = Typography;

interface Props {
  prefix: string;
}

export default function CustomerFinReport({ prefix }: Props) {
  return (
    <div>
      <Title level={4}>Бухгалтерская отчётность</Title>
      <BuhReport prefix={prefix} />
    </div>
  );
}
